export const PAYMENT_TYPE = {
  CREDIT: 'CREDIT',
  CASH: 'CASH',
}

export const PERSON_TYPE = {
  ORDINARY_PERSON: 'INDIVIDUAL',
  JURISTIC_PERSON: 'CORPORATION',
}

export const detailMode = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
}

export const STATUS_TYPE = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
}

export const BANK_ACCOUNT_TYPE = {
  SAVING: 'SAVING',
  FIXED: 'FIXED',
  CURRENT: 'CURRENT',
  FOREIGN: 'FOREIGN',
  BILL: 'BILL',
  LOTTERY: 'LOTTERY',
  BOND: 'BOND',
}

export const BANK_ACCOUNT_TYPE_TH = {
  SAVING: 'ออมทรัพย์',
  FIXED: 'ฝากประจำ',
  CURRENT: 'กระแสรายวัน',
  FOREIGN: 'สกุลเงินตราต่างประเทศ',
  BILL: 'ตั๋วแลกเงิน',
  LOTTERY: 'สลากออมทรัพย์',
  BOND: 'พันธบัตรรัฐบาล',
}
